import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-reservation-facility-reservation',
  templateUrl: './manual-reservation-facility-reservation.component.html',
  styleUrls: ['./manual-reservation-facility-reservation.component.css'],
  standalone: false,
})
export class ManualReservationFacilityReservationComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly nameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_NAME_DIALOG;
  readonly descDialogLink: string = AppConst.ROUTING_LINK_MANUAL_DESC_DIALOG;
  readonly uploaderLink: string = AppConst.ROUTING_LINK_MANUAL_UPLOADER;
  readonly reservationFacilityAttributeDialogLink: string = AppConst.ROUTING_LINK_MANUAL_RESERVATION_FACILITY_ATTRIBUTE_DIALOG;
  readonly youtubeDialogLink: string = AppConst.ROUTING_LINK_MANUAL_YOUTUBE_DIALOG;
  readonly urlDialogLink: string = AppConst.ROUTING_LINK_MANUAL_URL_DIALOG;
  readonly userInputTitleDialogLink: string = AppConst.ROUTING_LINK_MANUAL_USER_INPUT_TITLE_DIALOG;
  readonly sendMailTitleDialogLink: string = AppConst.ROUTING_LINK_MANUAL_SEND_MAIL_TITLE_DIALOG;
  readonly sendMailMessageDialogLink: string = AppConst.ROUTING_LINK_MANUAL_SEND_MAIL_MESSAGE_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
